export default __webpack_public_path__ + "static/media/button-small-pressed@2x.0d414769.png";